/** Comisión DLocal sobre el monto transaccionado (reflejada en sale order). */
export const DLOCAL_FEE_RATE = 0.054;

export const computeDLocalFeeAmount = (pendingAuthorization: number): number =>
	Math.round(pendingAuthorization * DLOCAL_FEE_RATE * 100) / 100;
